// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import React from 'react'
import {connect} from 'react-redux'
import moment from 'moment'

import './index.css'

class BuildId extends React.Component {
  formatDate (date) {
    let new_date = new Date(date * 1000)
    let string_date = moment(new_date).format('DD/MM/YYYY')
    return string_date
  }

  render () {
    if (!this.props.buildId)
      return null

    let buildId = {...this.props.buildId}
    buildId.build_date = this.formatDate(buildId.build_date)

    console.log(buildId)

    return (
      <p className='build-id pull-right'>
        Build {buildId.commit}
      </p>
    )
  }
}

function mapStateToProps ({buildId}) {
  return {buildId: buildId.buildId}
}

export default connect(mapStateToProps)(BuildId)
